import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Project } from 'src/app/_models';

@Component({
    standalone: false,
  selector: 'integration-apps-oscal-profile',
  templateUrl: './integration-apps-oscal-profile.component.html',
  styleUrls: ['./integration-apps-oscal-profile.component.css'],
})
export class IntegrationAppsOscalProfileComponent implements OnInit {
  @Input() settingsForm: FormGroup;
  @Input() projects: Project[];
  @Input() settings: any;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.settingsForm.addControl(
      'project',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'mergeSection',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'modifySection',
      this.fb.control('', Validators.required)
    );

    this.settingsForm.patchValue(this.settings);
  }
}
